import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { icons } from 'src/app/sharedcomp/constans/icons.constans';
import { Templates } from '../../../../_models/events.interface';
import { CustomerService, EventsService } from 'src/app/_services';
import { Subject, throwError } from 'rxjs';
import { catchError, finalize, map, takeUntil, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { EventsNewVersionService } from '../events-new-version.service';
import { EventsEdit, EventsEditSave, EventsSave } from 'src/app/_models';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/_helpers';
import { KeyEvents } from 'src/app/sharedcomp/constans/keyEvent.constans';

@Component({
  selector: 'app-modal-edit-event',
  templateUrl: './modal-edit-event.component.html',
  styleUrls: ['./modal-edit-event.component.css']
})
export class ModalEditEventComponent implements OnInit, OnDestroy {

  private unsubscribe$ = new Subject<void>();

  @Input() public_id: string;

  icons: typeof icons;
  iconsDropdown = "../../../../../assets/new-icons/order-icon.svg";
  templatesList: Templates[] = [];
  customer_public_id: string = '';
  templateListLimit: number = 100;
  detailEvent: EventsEdit;
  configValues = [];
  keyValues: string;
  editMode: boolean = false;
  selectedTemplateId: string;
  selectedTemplateName: string;

  eventsForm = new FormGroup({
    templates: new FormControl(''),
    customer_email: new FormControl(false),
    company_email: new FormControl(false),
    webhook: new FormControl(false),
  });

  constructor(public activeModal: NgbActiveModal, private customerService: CustomerService,
    private eventsNewVersionServices: EventsNewVersionService, private eventService: EventsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private dataService: DataService,
  ) {
    this.icons = icons;
  }

  ngOnInit() {
    this.customer_public_id = this.eventsNewVersionServices.public_id;
    this.getDetails();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  loadSpinnerStatus() {
    this.dataService.loadSpinnerSubject$
      .pipe(
        tap(status => {
          if (status) {
            this.spinnerService.show();
          } else {
            this.spinnerService.hide();
          }
        })
      )
      .subscribe();
  }

  getTemplateList(template_id: string | null) {
    this.spinnerService.show()
    this.customerService.getCustomerNotificationTemplateList(this.customer_public_id, this.templateListLimit)
      .pipe(
        takeUntil(this.unsubscribe$),
        map((respose) => {
          if (respose && Array.isArray(respose)) {
            this.templatesList = respose.filter(data => data.status = 'ACTIVE')
            if (template_id) {
              const templateFinded = this.templatesList.find(data => data.public_id == template_id);
              if (templateFinded) {
                this.selectedTemplateId = templateFinded.public_id;
                this.selectedTemplateName = templateFinded.name;
                this.editMode = true;
              }
            }
          } else {
            this.templatesList = [];
          }
        }),
        catchError(
          (error: HttpErrorResponse) => {
            this.templatesList = [];
            return throwError(error);
          }
        ), finalize(() => {
          this.spinnerService.hide();
        })
      ).subscribe()
  }

  getDetails() {
    this.spinnerService.show()
    this.eventService.getEventDetails(this.public_id)
      .pipe(
        takeUntil(this.unsubscribe$),
        map((response) => {
          if (response) {
            this.detailEvent = response;
            let templateValue: any;
            let companyEmailValue: boolean = false;
            let customerEmailValue: boolean = false;
            let webhookValue: boolean = false;

            for (let i = 0; i < response.values.length; i++) {
              if (response.key === "invoice.created" || response.key === "invoice.paid" || response.key === "invoice.rejected") {
                if (response.values[i].type === "customer_email") {
                  customerEmailValue = true;
                }

              }
              if (response.values[i].type === "email") {
                companyEmailValue = true;
              }
              if (response.values[i].type === "webhook") {
                webhookValue = true;
              }
            }
            if ((response.key === "invoice.created" || response.key === "invoice.paid" || response.key === "invoice.rejected")) {
              if (response.values) {
                const dataTemplate = response.values.find(data => data.type === "customer_email");
                if (dataTemplate) {
                  this.getTemplateList(dataTemplate.template_id ? dataTemplate.template_id : null);
                }else{
                  this.getTemplateList(null)
                }
              }
            }
            this.configValues = response.values;
            this.keyValues = response.key;
            this.eventsForm.patchValue({
              templates: templateValue,
              company_email: companyEmailValue,
              customer_email: customerEmailValue,
              webhook: webhookValue
            });
          }
        }),
        catchError(
          (error: HttpErrorResponse) => {
            return throwError(error);
          }
        ), finalize(() => {
          this.spinnerService.hide();
        })
      ).subscribe();
  }

  setTemplateType($event) {
  }

  customerEmailToggle(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.eventsForm.get('customer_email').setValue(isChecked);
    if (isChecked) {
      this.eventsForm.get('templates').setValidators([Validators.required]);
      this.eventsForm.get('templates').updateValueAndValidity();
    } else {
      this.eventsForm.get('templates').setValue("");
      this.eventsForm.get('templates').clearValidators();
      this.eventsForm.get('templates').updateValueAndValidity();
    }
  }

  companyEmailToggle(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.eventsForm.get('company_email').setValue(isChecked);
  }

  webhookToggle(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.eventsForm.get('webhook').setValue(isChecked);
  }

  onsubmitEventEditDetailsForm() {
    if (this.eventsForm.valid) {
      this.spinnerService.show();
      const dataToSave = this.editForm()
      let tempjsonValue = this.configValues;
      const keyEventValues = [
        KeyEvents.Created,
        KeyEvents.Paid,
        KeyEvents.Reject,
        KeyEvents.CratedPartial,
        KeyEvents.PaidPartial
      ];

      const updateItem = (type: string, condition: boolean, additionalProps?: object) => {
        const index = tempjsonValue.findIndex(item => item.type === type);
        if (condition) {
          if (index === -1) {
            tempjsonValue.push({ type, ...additionalProps });
          } else if (additionalProps) {
            tempjsonValue[index] = { ...tempjsonValue[index], ...additionalProps };
          }
        } else {
          if (index !== -1) {
            tempjsonValue.splice(index, 1);
          }
        }
      };

      if (keyEventValues.includes(this.keyValues)) {
        updateItem('customer_email', dataToSave.customeremail, { template_id: dataToSave.template });
      }

      updateItem('email', dataToSave.companyemail);
      updateItem('webhook', dataToSave.webhook);

      const values = { values: tempjsonValue };

      this.eventService.updateEvents(this.public_id, values)
        .pipe(
          takeUntil(this.unsubscribe$),
          map((response => {

          })),
          catchError(
            (error: HttpErrorResponse) => {
              return throwError(error);
            }
          ), finalize(() => {
            this.spinnerService.hide();
            this.activeModal.close();
          })
        ).subscribe();
    }
  }

  editForm(): EventsEditSave {
    const {
      webhook,
      company_email,
      customer_email,
      templates
    } = this.eventsForm.getRawValue();

    return {
      customeremail: customer_email,
      template: templates || this.selectedTemplateId,
      companyemail: company_email,
      webhook: webhook,
    }
  }

  closeModal(reason: string) {
    this.activeModal.close(reason);
  }
}
